module.exports = __webpack_public_path__ + "assets/img/skin_5.fc684a3b.jpg";